angular.module('schemaForm').config(['schemaFormProvider',
    'schemaFormDecoratorsProvider', 'sfPathProvider',
    function(schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {

        //Creates an default titleMap list from an enum, i.e. a list of strings.
        var enumToTitleMap = function(enm) {
            var titleMap = []; //canonical titleMap format is a list.
            enm.forEach(function(name) {
                titleMap.push({name: name, value: name});
            });
            return titleMap;
        };

        var stripNullType = function(type) {
            if (Array.isArray(type) && type.length == 2) {
                if (type[0] === 'null')
                    return type[1];
                if (type[1] === 'null')
                    return type[0];
            }
            return type;
        };

        var array = function(name, schema, options) {
            if (stripNullType(schema.type) === 'array') {
                var f   = schemaFormProvider.stdFormObj(name, schema, options);
                f.type  = 'array';
                f.key   = options.path;
                options.lookup[sfPathProvider.stringify(options.path)] = f;

                var required = schema.required &&
                    schema.required.indexOf(options.path[options.path.length - 1]) !== -1;
                // The default is to always just create one child. This works since if the
                // schemas items declaration is of type: "object" then we get a fieldset.
                // We also follow json form notatation, adding empty brackets "[]" to
                // signify arrays.

                var arrPath = options.path.slice();
                arrPath.push('');

                f.items = [schemaFormProvider.defaultFormDefinition(name, schema.items, {
                    path: arrPath,
                    required: required || false,
                    lookup: options.lookup,
                    ignore: options.ignore,
                    global: options.global
                })];
                return f;
            }
        };

        // Add our default to the defaults array
        angular.forEach(schemaFormProvider.defaults.array, function(value, i){
            if (value.name == 'array') {
                schemaFormProvider.defaults.array[i] = array;
            }
        });

        // Second, we want it to show if someone have explicitly set the form type
        schemaFormDecoratorsProvider.addMapping('bootstrapDecorator', 'array',
            'app/schema-form-component/angular-schema-form-array/angular-schema-form-array.html');

    }]);
